import { CanvaSX } from '../canvasx';
import { defaultShapeProps } from '../shapes';
import { calculateDimensionsForProps, drawRect } from '../util';

// Perform custom rendering inside CanvaSX - i.e. escape from CanvaSX back to
// raw canvas rendering.
const defaultCanvasProps = { ...defaultShapeProps };
export type CanvasProps = Partial<ShapeStruct> & {
  render: (ctx: CanvasRenderingContext2D) => void;
};
export const Canvas: CanvaSXComponent<CanvasProps, typeof defaultCanvasProps> =
  function (props) {
    let { children, width, height } = props;
    const { ctx } = CanvaSX.context;

    if (typeof width !== 'number' || typeof height !== 'number') {
      const dimensions = calculateDimensionsForProps(props);
      if (typeof width !== 'number') {
        width = dimensions.width;
      }
      if (typeof height !== 'number') {
        height = dimensions.height;
      }
    }

    if (Array.isArray(children) && children.length > 0) {
      throw new Error('Canvas does not support children.');
    }

    drawRect(ctx, { ...props, width, height }, () => {
      if (props.render) props.render(ctx);
    });

    return null;
  };

Canvas.defaultProps = defaultCanvasProps;
